module.exports = __webpack_public_path__ + "img/干果1.95cddcdf.png";